// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3qD6w","controls":"styles_controls__30A-N","charLimit":"styles_charLimit__1y0Gj","input":"styles_input__3XQyt","send":"styles_send__GnlGE"};